import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../assets/styles/Admin.module.scss';

interface PreRegistration {
  id: number;
  company_name: string;
  last_name: string;
  first_name: string;
  email: string;
  tel_num: string;
  company_role: string;
  monthly_ad_budget_range: string;
  is_approved: boolean;
  created_at: string;
}

import { ROLE_MAP, BUDGET_MAP } from '../../utils/constants';
import { formatDate } from '../../utils/date';

const AdminRegistrations: React.FC = () => {
  const navigate = useNavigate();
  const [registrations, setRegistrations] = useState<PreRegistration[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRegistrations = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/admin/registrations/list`, {
          credentials: 'include'
        });
        if (res.ok) {
          const data = await res.json();
          setRegistrations(data);
        } else {
          const text = await res.text();
          console.error('Fetch failed:', text);
          alert(`Fetch failed: ${res.status} ${text}`);
        }
      } catch (error) {
        console.error('Failed to fetch registrations', error);
        alert('事前登録一覧の取得に失敗しました。');
      } finally {
        setLoading(false);
      }
    };
    fetchRegistrations();
  }, []);

  const handleRowClick = (id: number) => {
    navigate(`/admin/registrations/${id}`);
  };

  return (
    <div className={styles.contentBox}>
      <div className={styles.pageHeader}>
        <h1>新規会員登録</h1>
        <p>新規の会員登録申し込み一覧</p>
      </div>

      <div className={styles.tableWrap}>
        <table className={styles.adminTable}>
          <thead>
            <tr>
              <th>ID</th>
              <th>会社名</th>
              <th>担当者名</th>
              <th>メールアドレス</th>
              <th>電話番号</th>
              <th>立場</th>
              <th>広告予算</th>
              <th>登録日</th>
              <th>ステータス</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} style={{ textAlign: 'center' }}>読み込み中...</td></tr>
            ) : registrations.map((reg) => (
              <tr key={reg.id} onClick={() => handleRowClick(reg.id)}>
                <td>{reg.id}</td>
                <td>{reg.company_name}</td>
                <td>{reg.last_name} {reg.first_name}</td>
                <td>{reg.email}</td>
                <td>{reg.tel_num || '-'}</td>
                <td>{reg.company_role ? (ROLE_MAP[reg.company_role] || reg.company_role) : '-'}</td>
                <td>{reg.monthly_ad_budget_range ? (BUDGET_MAP[reg.monthly_ad_budget_range] || reg.monthly_ad_budget_range) : '-'}</td>
                <td>{formatDate(reg.created_at)}</td>
                <td>
                  <span className={`${styles.badge} ${reg.is_approved ? styles.inactive : styles.active}`}>
                    {reg.is_approved ? '完了' : '未対応'}
                  </span>
                </td>
              </tr>
            ))}
            {!loading && registrations.length === 0 && (
              <tr><td colSpan={9} style={{ textAlign: 'center' }}>登録はありません</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminRegistrations;
